import { Col } from 'antd';
import React, { useCallback } from 'react';
import { SearchFilter, SearchFilterContainer } from '../filters';
export const FieldUpdateSearch = ({ onChange }) => {
    const handleChange = useCallback((params) => {
        onChange({ filters: params.query ? `DisplayName~like~"%${params.query}%"` : undefined });
    }, [onChange]);
    return (React.createElement(SearchFilterContainer, null,
        React.createElement(Col, { span: 12 },
            React.createElement(SearchFilter, { onChange: handleChange }))));
};
